import { useFullScreenModeEnabled } from "../../store/model-misc";
import { useTableName } from "./my-ag-grid-react-context";

export function useGridBorderRadius() {
  const fullScreen = useFullScreenModeEnabled();
  const tableName = useTableName();
  return fullScreen && tableName === "churn_risk" ? "0" : "4px";
}
